import { cn } from "../../lib/cn.js";

/**
 * Friendly empty-state for list pages with no rows.
 *
 *   <EmptyState
 *     icon={<Inbox />}
 *     title="No submissions yet"
 *     description="Forms submitted on the public site will appear here."
 *     action={<Button>Refresh</Button>}
 *   />
 */
export function EmptyState({ icon, title, description, action, className }) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center rounded-xl border border-dashed border-border-subtle bg-bg-elevated px-6 py-16 text-center",
        className
      )}
    >
      {icon && (
        <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-bg-elevated-2 text-text-muted">
          {icon}
        </div>
      )}
      {title && <h3 className="text-base font-display text-text-primary">{title}</h3>}
      {description && <p className="mt-1 max-w-md text-sm text-text-secondary">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
